export interface ActionRequest<A extends string, M> {
	resourceId: string; // Hashed resource ID
	resourceType: UserEventResourceType;
	action: A;
	metaData: M;
}

export enum UserEventResourceType {
	GROUP = 'group',
	EVENT = 'event',
}
